import { IHostEarnings, EarningsGranularity, EarningsScope } from '../interfaces/heavyDutyMachinery/IHostEarnings';
import { apiService } from './ApiService';
import { API_ENDPOINTS } from '../constants/apiEndpoints';
import { HTTP_METHODS } from '../constants/httpMethods';

const heavyDutyMachineryBaseUrl = process.env.REACT_APP_HEAVY_DUTY_MACHINERY_API_URL || '';

/**
 * The caller's own earnings for a window. Answers for a host who has never
 * rented anything out -- every figure zero and both lists empty, which is
 * what the empty state renders from.
 *
 * `from`/`to` are ISO dates; the server treats `to` as inclusive of that
 * whole day. Omitting them asks for the last 12 months.
 */
export const getMyHostEarnings = async (params?: {
  from?: string;
  to?: string;
  granularity?: EarningsGranularity;
  /** Narrows the RANGE figures only. Omitted means 'all'; an unknown value is normalised to 'all' server-side rather than rejected. */
  scope?: EarningsScope;
}): Promise<IHostEarnings> => {
  const query = new URLSearchParams();
  if (params?.from) query.set('from', params.from);
  if (params?.to) query.set('to', params.to);
  if (params?.granularity) query.set('granularity', params.granularity);
  if (params?.scope && params.scope !== 'all') query.set('scope', params.scope);
  const suffix = query.toString();

  const response = await apiService<IHostEarnings>({
    url: `${API_ENDPOINTS.HEAVY_DUTY_MACHINERY_HOST_EARNINGS}${suffix ? `?${suffix}` : ''}`,
    method: HTTP_METHODS.GET,
    baseUrl: heavyDutyMachineryBaseUrl,
  });
  if (response.success) return response.data;
  throw new Error(response.error || 'Failed to load the earnings');
};
